import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_PRODUCT_ADDITION_SUCCESS =
  "SHOP:UPSERT_PRODUCT_ADDITION_SUCCESS";

export const upsertProductAdditionSuccessAction = (
  organization: OrganizationKeyName,
  id?: string
) => ({
  type: UPSERT_PRODUCT_ADDITION_SUCCESS as typeof UPSERT_PRODUCT_ADDITION_SUCCESS,
  organization,
  id,
});

export type UpsertProductAdditionSuccessAction = ReturnType<
  typeof upsertProductAdditionSuccessAction
>;
